export const useStyles = () => {
  return {
    dialogPaper: {
      background:
        'linear-gradient(135deg, rgba(28, 28, 34, 0.88) 0%, rgba(16, 16, 20, 0.88) 100%)',
      backdropFilter: 'blur(18px)',
      WebkitBackdropFilter: 'blur(18px)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      boxShadow: '0 18px 50px rgba(0, 0, 0, 0.45)',
      borderRadius: '16px',
      color: '#e2e4ed',
      minWidth: '320px',

      '& .MuiDialogTitle-root': { color: '#e2e4ed' },
      '& .MuiDialogContentText-root': { color: '#e2e4ed' },
      '& .MuiButton-text': { color: '#e2e4ed' },
      '& .MuiFormControlLabel-label': { color: '#e2e4ed' },
      '& .MuiRadio-root': { color: 'rgba(226, 228, 237, 0.6)' },
      '& .MuiRadio-root.Mui-checked': { color: '#e2e4ed' },
    },
  };
};
